import {
    CLOSE_QUICKSHOP,
    NEXT_QUICKSHOP_PRODUCT,
    LOAD_QUICKSHOP,
    PREVIOUS_QUICKSHOP_PRODUCT,
    SAVE_QUICKSHOP_ITEM,
    QUICKSHOP_SAGAS_INITIALIZED
} from '../enums/quickshopEnums';

export function closeQuickshop(e, component) {
    return {
        type: CLOSE_QUICKSHOP,
        payload: {},
        meta: {
            event: e,
            component: component
        }
    };
}

export function nextQuickshopProduct(e, component) {
    return {
        type: NEXT_QUICKSHOP_PRODUCT,
        payload: {},
        meta: {
            event: e,
            component: component
        }
    };
}

export function previousQuickshopProduct(e, component) {
    return {
        type: PREVIOUS_QUICKSHOP_PRODUCT,
        payload: {},
        meta: {
            event: e,
            component: component
        }
    };
}

/**
 * Saves the full product tile into the quickshop store
 */
export function saveQuickshopItem(data) {
    return {
        type: SAVE_QUICKSHOP_ITEM,
        payload: data
    };
}

export function loadQuickshop(data, e, component) {
    data.isOpen = true;

    return {
        type: LOAD_QUICKSHOP,
        meta: {
            event: e,
            component: component
        },
        payload: data
    };
}

export function quickshopSagasInitialized(data) {
    return {
        type: QUICKSHOP_SAGAS_INITIALIZED,
        payload: data
    };
}
